<template>
  <div class="main">
    <section class="panel">
      <header class="panel-heading">
        <h2 class="panel-title">離退宿 QRCode 審查</h2>
      </header>
      <div class="panel-body">
        <p v-if="loading">資料驗證中，請稍候...</p>
        <div v-else>
          <p :class="statusClass">{{ message }}</p>
        </div>
        <div style="margin-top: 12px;">
          <button class="btn btn-default" @click="goBack">返回</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      message: "",
      statusClass: "text-info",
    };
  },
  mounted() {
    const token = this.$route.query.token;
    if (!token) {
      this.loading = false;
      this.statusClass = "text-danger";
      this.message = "缺少 QRCode 資料";
      return;
    }

    if (!this.sessionData || !this.sessionData.account) {
      // 尚未登入:保留 QRCode token,開啟登入視窗(登入成功後由 App.vue 導回本頁)
      // 存 localStorage:登入流程會呼叫 clearStore()(= sessionStorage.clear()),sessionStorage 會被清掉
      localStorage.setItem("pendingLeaveReviewToken", token);
      this.showLoginPopup();
      this.loading = false;
      this.statusClass = "text-info";
      this.message = "請先登入後，系統將自動開啟離退宿審查單。";
      return;
    }

    this.doResolve(token);
  },
  methods: {
    doResolve(token) {
      this.loading = true;
      this.$axios.post("/api/Room/resolveLeaveQrcode", { token }).then((resp) => {
        if (resp.data.status === "success") {
          const data = resp.data.data;
          this.setStore("stay.leave.apply", {
            leaveType: data.leaveType,
            id: data.applyId,
            idno: data.idno,
            account: data.account,
          });
          this.$router.replace({ name: "stay.leave.apply" });
        } else {
          this.loading = false;
          this.statusClass = "text-danger";
          this.message = resp.data.msg || "QRCode 驗證失敗";
        }
      }).catch(() => {
        this.loading = false;
        this.statusClass = "text-danger";
        this.message = "QRCode 驗證失敗，請稍後再試";
      });
    },
    goBack() {
      // 用整頁導回首頁,讓 App.vue 重新掛載(URL 不帶 query)以重建側邊選單
      window.location.href = "/";
    },
  },
};
</script>

<style scoped>
</style>
